/* global $ */
/* global URLS */
/* global gettext */

(function (sculpteo) {
  "use strict";

  /**
   * @constructor
   * @param {sculpteo.PrintController} controller
   * @param {Design} design
   */
  var PrintSeriesView = (sculpteo.PrintSeriesView = function (
    controller,
    design
  ) {
    this.controller = controller;
    this.design = design;

    this.$el = $(".PrintSeriesView");

    /**
     * The pricesByQuantity plays the role of a cache.
     * We save the prices and delays for a specific configuration.
     * When the configuration is changed (size, material, ...) this cache is reset.
     *
     * The object is structured this way :
     *
     * this.pricesByQuantity = {
     * 		"1" : priceStructureFor1Part,
     * 		"5" : priceStructureFor5Parts,
     * 		"10" : priceStructureFor10Parts,
     * 		}
     */
    this.pricesByQuantity = {};

    /**
     * The defaultQuantitiesByMode is an object containing the preset quantities
     * by production modes depending on the size of the printed model
     * (computed server side)
     */
    this.defaultQuantitiesByMode = {
      fast_mode: [],
      next_day_mode: [],
      economy_mode: [],
      standard_mode: [],
    };

    this.userQuantity = null;

    this.dom = {
      $loadingState: this.$el.find(".loading-state"),
      $userQuantityInput: this.$el.find("input.user-quantity"),
    };

    this.setupDOMListeners();
  });

  PrintSeriesView.prototype.setupDOMListeners = function () {
    this.$el.on(
      "click",
      ".price-quantity-line:not(.errors)",
      function (e) {
        // TODO: debounce
        var $row = $(e.currentTarget);

        // Immediately show the line as selected for ux responsiveness
        // even though the controller callback quantityChanged will re-update it eventually
        this.$el.find(".price-quantity-line").removeClass("selected");
        $row.addClass("selected");

        this.controller.updateQuantity(parseInt($row.data("quantity")));
      }.bind(this)
    );

    this.dom.$userQuantityInput.change(
      function (e) {
        this.userQuantityInputChanged(e);
      }.bind(this)
    );

    this.$el.on("click", ".delete-row", this.deletePricesArrayRow.bind(this));
    this.$el.on(
      "click",
      ".settings-description-container",
      this.goToSettings.bind(this)
    );
  };

  /**
   * Fetches prices for current state then refresh (re-render for now) the DOM
   * @private
   */
  PrintSeriesView.prototype.reload = function () {
    if (this.userQuantity == null) {
      // if there is no user quantity yet, use the value from the current quantity
      this.userQuantity = this.design.order.quantity;
    }
    this.dom.$userQuantityInput.attr("min", 1);
    this.fetchPrices().then(
      function () {
        // Autoswitch to standard if we have no price for quantity 1  // TODO: find a better place (breaks separation of concerns)
        if (
          this.getSelectedMode() != "standard_mode" &&
          this.getSelectedMode() != "next_day_mode"
        ) {
          if (
            this.pricesByQuantity.hasOwnProperty(1) === -1 ||
            PriceDataUtils.getErrors(
              this.pricesByQuantity[1],
              this.getSelectedMode()
            ).length > 0
          ) {
            // got no price for quantity 1 or it has errors
            console.warn(
              "No price for quantity 1 (" +
                this.getSelectedMode() +
                "), switching to standard_mode"
            );
            this.controller.views.price.selectProductionMode("standard_mode");
            return;
          }
        }

        this.render();
      }.bind(this)
    );
  };

  /**
   * Controller callbacks
   */
  PrintSeriesView.prototype.productionModeChanged = function () {
    // console.log("PrintSeriesView.productionModeChanged");

    if (
      this.defaultQuantitiesByMode[this.getSelectedMode()].indexOf(
        this.design.order.quantity
      ) == -1 &&
      this.design.order.quantity != this.userQuantity
    ) {
      // Current quantity is neither the user quantity nor a default one (e.g you had selected a default qty that is unique to a production mode)
      this.userQuantity = this.design.order.quantity;
      this.reload();
    } else {
      this.render();
    }
  };

  PrintSeriesView.prototype.materialChanged = function () {
    // console.log("PrintSeriesView.materialChanged", this.design.material);
    this.reload();
  };

  PrintSeriesView.prototype.unitChanged = function () {
    // console.log("PrintSeriesView.unitChanged");
    this.reload();
  };

  PrintSeriesView.prototype.orientationChanged = function () {
    // console.log("PrintSeriesView.orientationChanged");
    this.reload();
  };

  PrintSeriesView.prototype.currencyChanged = function () {
    // console.log("PrintSeriesView.currencyChanged");
    this.reload();
  };

  PrintSeriesView.prototype.scaleChanged = function () {
    // console.log("PrintSeriesView.scaleChanged");
    this.reload();
  };

  PrintSeriesView.prototype.quantityChanged = function () {
    // console.log("PrintSeriesView.quantityChanged");

    if (
      this.defaultQuantitiesByMode[this.getSelectedMode()].indexOf(
        this.design.order.quantity
      ) == -1 &&
      this.design.order.quantity != this.userQuantity
    ) {
      // This is neither the current userQuantity nor a default one
      this.userQuantity = this.design.order.quantity;
      this.reload();
    } else {
      // Select current quantity if it is one of the existing lines
      this.selectQuantity(this.design.order.quantity);
    }

    // Update classic mode quantity input
    // directly via DOM for now (this doesn't trigger another quantity change)
    // ideally should be in PrintPriceView response to a quantityChanged callback
    $("div.PrintPriceView div.forms.quantity input").val(
      this.design.order.quantity
    );
  };

  /**
   * Adds selected class to a row of the table, will unselect all if that quantity is not part of the table
   */
  PrintSeriesView.prototype.selectQuantity = function (quantity) {
    this.$el.find(".price-quantity-line").removeClass("selected");

    var $rows = this.$el.find(
      '.price-quantity-line[data-quantity="' + quantity + '"]'
    );
    if ($rows.length) {
      $rows.addClass("selected");
    }
  };

  PrintSeriesView.prototype.userQuantityInputChanged = function (e) {
    var $input = $(e.currentTarget);

    // console.log("PrintSeriesView.userQuantityInputChanged", $input.val());

    // input validation
    var quantity = parseInt($input.val());
    var min = parseInt($input.attr("min"), 10);
    var max = parseInt($input.attr("max"), 10);

    if (isNaN(quantity)) {
      this.controller.notify("warn", "personalized_quantity_not_number", true);
      return;
    }
    if (quantity < min) {
      this.controller.notify("warn", "min_personalized_quantity", true, min);
      return;
    }
    if (quantity > max) {
      this.controller.notify("warn", "max_personalized_quantity", true, max);
      return;
    }

    this.userQuantity = quantity;
    this.reload();
    //this.selectQuantity(quantity); // that should be a reload().then(
    this.controller.updateQuantity(quantity);
  };

  PrintSeriesView.prototype.getSelectedMode = function () {
    return this.design.order.production_mode || "standard_mode";
  };

  /**
   * Format price with the good decimal separator and currency symbol
   * @private
   * @param {float} price
   */
  PrintSeriesView.prototype.formatPrice = function (price, withoutCurrency) {
    return this.controller.formatPrice(price, withoutCurrency);
  };

  /**
   */
  PrintSeriesView.prototype.fetchPrices = function () {
    var deferred = $.Deferred();

    //this.dom.$loadingState.show();

    var parts = this.design.explode
      ? Object.values(this.design.partitioning.parts)
      : [this.design];
    var data = {};
    // Build query parameters
    for (var k = 0; k < parts.length; k++) {
      var part = parts[k];
      if (part.model_uuid) {
        data["editinfo_" + k] = part.model_uuid;
      } else {
        data["uuid_" + k] = part.design_uuid;
      }
      if (part.size.size_id) {
        data["size_" + k] = part.size.size_id;
      }

      data["quantity_" + k] =
        this.userQuantity !== null ? this.userQuantity : undefined;
      data["scale_" + k] = part.size.userScale;
      data["unit_" + k] = part.size.unit;
      data["material_" + k] = part.material.slug;
      data["currency_" + k] = part.order.currency;
      data["finish_" + k] = part.order.finish;
      data["painting_" + k] = part.order.painting;
      // TODO: not really supporting multipart; not dry
      const $details_form = $(".PrintDetailsForm");
      if (
        $details_form.length &&
        $details_form.find("input[name='submitted']").val() === "1"
      ) {
        data.details = $details_form.serialize();
      } else {
        data.details = "";
      }
    }

    data.no_delays = "1";
    data["next_day_option"] = 1;

    var do_request;
    if (parts.length < 40) {
      // TODO: get away with this get/post crazyness :)
      do_request = $.get;
    } else {
      do_request = $.post;
    }

    var _this = this;

    do_request(URLS.x_get_price_array, data)
      .done(function (response) {
        if (
          !response.hasOwnProperty("prices") ||
          !response.hasOwnProperty("quantities")
        ) {
          console.error("Price request received invalid response", response);
          deferred.reject();
          return;
        }

        _this.pricesByQuantity = response.prices;
        _this.defaultQuantitiesByMode = response.quantities;

        deferred.resolve();
      })
      .fail(function () {
        console.error("Price request failed");
        deferred.reject();
      })
      .always(function () {
        //_this.dom.$loadingState.hide();
      });

    return deferred;
  };

  PrintSeriesView.prototype.thousandWithSpace = function (price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  /**
   *  This function handles the price array display.
   *
   */
  PrintSeriesView.prototype.render = function () {
    var array = $(".price-array", this.$el);

    array.addClass("price-array-blue");
    $(".nav-shopping-badge1").css({ "background-color": "#85C7F7" });

    // set user quantity input value
    this.dom.$userQuantityInput.val(this.userQuantity);

    var quantities = this.defaultQuantitiesByMode[
      this.getSelectedMode()
    ].concat([this.userQuantity]);
    var removeDuplicate = function (array) {
      return array.filter(function (v, i) {
        return array.indexOf(v) === i;
      });
    };
    quantities = removeDuplicate(quantities);

    $(".price-quantity-line", this.$el).remove(); // Clear the table

    var is_business_rewards_prices = PriceDataUtils.hasBusinessRewardsPrices(
      quantities,
      this.pricesByQuantity
    );
    if (is_business_rewards_prices) {
      array.addClass("business-rewards");
      $("th[data-price-title] span:first-child", array).hide();
      $("th[data-price-title] span:last-child", array).show();
    } else {
      array.removeClass("business-rewards");
      $("th[data-price-title] span:last-child", array).hide();
      $("th[data-price-title] span:first-child", array).show();
    }
    var renderedOne = false;
    quantities.forEach(
      function (quantity) {
        if (this.pricesByQuantity.hasOwnProperty(quantity)) {
          var $row = this.generatePricesArrayRow(
            this.pricesByQuantity[quantity],
            is_business_rewards_prices
          );
          $row.insertBefore($(".personnalized-quantity-line"));
          renderedOne = true;
        }
      }.bind(this)
    );

    if (!renderedOne) {
      // Disabled style
      array.removeClass("price-array-green");
      array.removeClass("price-array-blue");
    }
  };

  PrintSeriesView.prototype.generatePricesArrayRow = function (
    price,
    is_business_rewards_prices
  ) {
    var productionMode = this.getSelectedMode();
    var quantity = price.quantity;

    var $row = $("<tr>")
      .addClass("price-quantity-line")
      .attr("data-quantity", quantity);

    var $quantityCell = $("<td>")
      .append($("<div>").addClass("rightarrow"))
      .append($("<p>").addClass("quantity-cell").html(quantity));

    if (this.defaultQuantitiesByMode[productionMode].indexOf(quantity) == -1) {
      // This is a user quantity
      $("<span>")
        .addClass("delete-row")
        .text("x")
        .insertBefore($(".quantity-cell", $quantityCell));
    }

    var errors = PriceDataUtils.getErrors(price, productionMode, true);

    $(".add-to-cart-button").removeClass("disabled");
    $(".price-button button").addClass("add-to-cart-button");
    $("#quote_msg").remove();

    if (errors.length > 0) {
      var $unitPrice = $("<td>").append(
        $("<p>").html(this.thousandWithSpace(this.formatPrice(0)))
      );

      var $totalCost = $("<td>").append(
        $("<p>").html(this.thousandWithSpace(this.formatPrice(0)))
      );

      if (errors[0] == "get_a_quote") {
        $unitPrice = $("<td>").append(
          $('<p class="text-cell">').html(
            gettext("(Online pricing not available)")
          )
        );
        $totalCost = $('<td class="button-cell">').append(
          $('<button class="quote-button">').html(gettext("Get a quote"))
        );
      }

      if (errors[0] == "min_quantity") {
        $unitPrice = $("<td>").append(
          $('<p class="text-cell">').html(
            gettext("(Impossible to order this quantity)")
          )
        );
      }

      if (window.sculpteo.debug == "2") {
        // Show errors in the array when debug = 2
        $unitPrice = $("<td>")
          .attr("colspan", "2")
          .append($("<p>").html(errors.join("<br/>")));
        $totalCost = null;
      }
    } else {
      var price_text = this.thousandWithSpace(
        this.formatPrice(
          PriceDataUtils.getUnitPrice(
            price,
            productionMode,
            this.design.order.finish,
            this.design.order.painting
          )
        )
      );
      if (is_business_rewards_prices) {
        $row.addClass("business-rewards");
        price_text =
          price_text +
          "<br><span>" +
          this.thousandWithSpace(
            this.formatPrice(
              PriceDataUtils.getUnitPrice(
                price,
                productionMode,
                this.design.order.finish,
                this.design.order.painting,
                true
              )
            )
          ) +
          "</span>";
      }
      var $unitPrice = $("<td>").append($("<p>").html(price_text));

      var $totalCost = $("<td>").append(
        $("<p>").html(
          this.thousandWithSpace(
            this.formatPrice(
              PriceDataUtils.getTotalPrice(
                price,
                productionMode,
                this.design.order.finish,
                this.design.order.painting
              )
            )
          )
        )
      );
    }

    if (quantity == this.design.order.quantity) {
      // This is the currently selected quantity
      $row.addClass("selected");
    }

    $row.append($quantityCell).append($unitPrice).append($totalCost);
    return $row;
  };

  /**
   * This function delete a price array row
   * when clicking on the left cross of the row
   *
   */
  PrintSeriesView.prototype.deletePricesArrayRow = function (e) {
    e.stopPropagation();
    var $row = $(e.currentTarget).closest("tr");
    $row.remove();

    this.userQuantity = null;

    //this.selectLineInPricesArray(1);  //TODO: check and do something if it was the current quantity
  };

  PrintSeriesView.prototype.goToSettings = function (event) {
    var settings = $(".PrintSettingsView");
    var $container = $("html,body");
    // Scroll
    $container.animate(
      {
        scrollTop: settings.offset().top,
        scrollLeft: 0,
      },
      "slow"
    );
  };
})((window.sculpteo = window.sculpteo || {}));
